'use strict';

import VanillaModal from 'vanilla-modal';

import docinfo from './components/docinfo';
import menu from './components/menu';
import cover from './components/cover';
import gallery from './components/gallery';
import sections from './components/sections';
import endnote from './components/endnote';
import jumper from './components/jumper';
import i18n from './i18n/i18n-handler';

// INIT
i18n.init();
jumper.init({ duration: 1000, offset: -80 });
menu.init();
cover.init();
gallery.init();
endnote.init();

const modal = new VanillaModal();

document.addEventListener('DOMContentLoaded', () => {
  const shouldLinkfy = document.querySelectorAll('.linkfy');

  for (let index = 0; index < shouldLinkfy.length; index++) {
    shouldLinkfy[index].innerHTML = linkify(shouldLinkfy[index].innerHTML);
  }

  if(docinfo.isMobile()) {
    document.body.classList.add('is-mobile');
  }
});

// WHEN WINDOW SCROLLS
window.addEventListener('scroll', () => {
  menu.scrollHandler();
  sections.scrollHandler();
});

// WHEN WINDOW RESIZES
// if (!docinfo.isMobile()) {
let windowTimeout = null;
window.onresize = () => {
  if (windowTimeout !== null) {
    clearTimeout(windowTimeout);
  }

  windowTimeout = setTimeout(() => {
    cover.setSize();
  }, 500);
};
// }
